import { render, staticRenderFns } from "./CardContratoEndereco.vue?vue&type=template&id=0653fe92&lang=pug"
import script from "./CardContratoEndereco.vue?vue&type=script&lang=js"
export * from "./CardContratoEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports